export { Chrome } from './components/Chrome';
export { ContentSecurityPolicy } from './components/ContentSecurityPolicy';
export { productionFallbacks, beforeFiles } from './lib/s4mpRewrites';
export { locales, prodLocales, devLocales, routeExposedLocales, DEFAULT_LOCALE, } from './lib/locales';
export { login } from './lib/login';
//# sourceMappingURL=index.js.map